export default __webpack_public_path__ + "static/media/pg-41.0ee1c1fb.jpg";